import React from 'react';
import { Link } from 'react-router-dom';
import Menu from 'antd/lib/menu';
import _ from 'lodash';

import allBillersRoute from 'modules/AllBillers/route';
import { AllBillerIcon } from 'modules/AllBillers/components/Icons';
import { permissionService } from 'shared/services';

const { SubMenu } = Menu;
const { checkPermission } = permissionService;

const AllBillersMenu = location => {
  const pathname = _.get(location, 'pathname', '');
  let serviceMenu;
  let formMenu;
  let billerMenu;
  let tncMenu;
  let transactionMenu;
  // let aggregatorMenu;
  // let settlementMenu;
  if (pathname.includes(allBillersRoute.SERVICES)) {
    serviceMenu = pathname;
  }
  if (pathname.includes(allBillersRoute.FORM_BUILDERS)) {
    formMenu = pathname;
  }
  if (pathname.includes(allBillersRoute.BILLERS)) {
    billerMenu = pathname;
  }
  if (pathname.includes(allBillersRoute.TRANSACTIONS)) {
    transactionMenu = pathname;
  }
  if (pathname.includes(allBillersRoute.TNC_LIST)) {
    tncMenu = pathname;
  }
  // if (pathname.includes(allBillersRoute.AGGREGATORS)) {
  //   aggregatorMenu = pathname;
  // }
  // if (pathname.includes(allBillersRoute.SETTLEMENT)) {
  //   settlementMenu = pathname;
  // }

  return (
    <SubMenu
      key="biller"
      title={
        <span className="center-content">
          <AllBillerIcon />
          <span>All Biller</span>
        </span>
      }
    >
      {checkPermission('Form Builder:read', true) && (
        <Menu.Item key={formMenu}>
          <Link to={allBillersRoute.FORM_BUILDERS}>
            <span>Form Builder</span>
          </Link>
        </Menu.Item>
      )}
      {/* <Menu.Item key={aggregatorMenu}>
        <Link to={allBillersRoute.AGGREGATORS}>
          <span>Aggregator</span>
        </Link>
      </Menu.Item> */}
      {checkPermission('Service:read', true) && (
        <Menu.Item key={serviceMenu}>
          <Link to={allBillersRoute.SERVICES}>
            <span>Service</span>
          </Link>
        </Menu.Item>
      )}
      {checkPermission('Biller:read', true) && (
        <Menu.Item key={billerMenu}>
          <Link to={allBillersRoute.BILLERS}>
            <span>Billers</span>
          </Link>
        </Menu.Item>
      )}
      {checkPermission('Transaction Log:read', true) && (
        <Menu.Item key={transactionMenu}>
          <Link to={allBillersRoute.TRANSACTIONS}>
            <span>Transaction Log</span>
          </Link>
        </Menu.Item>
      )}
      {checkPermission('Tnc:read', true) && (
        <Menu.Item key={tncMenu}>
          <Link to={allBillersRoute.TNC_LIST}>
            <span>Terms & Conditions</span>
          </Link>
        </Menu.Item>
      )}
      {/* <Menu.Item key={settlementMenu}>
        <Link to={allBillersRoute.SETTLEMENT}>
          <span>Settlement</span>
        </Link>
      </Menu.Item> */}
    </SubMenu>
  );
};

export default AllBillersMenu;
